import { Badge, Group, TextInput } from "@mantine/core"
import { useMemo, useState } from "react"
import { AuthenticatedAppShell } from "../../../components/authenticated-app-shell"
import { Link } from "../../../components/link"
import { AppCard, PageToolbar } from "../../../components/ui"
import { docsArticles, docsSections } from "./docs-registry"

export function AppDocsPage() {
  const [query, setQuery] = useState("")
  const normalizedQuery = query.trim().toLowerCase()
  const visibleArticles = useMemo(
    () =>
      docsArticles.filter((article) => {
        if (!normalizedQuery) return true
        return [article.title, article.description, article.section, ...article.tags]
          .join(" ")
          .toLowerCase()
          .includes(normalizedQuery)
      }),
    [normalizedQuery]
  )

  return (
    <AuthenticatedAppShell eyebrow="Docs" title="Adgiro docs">
      {() => (
        <div className="app-docs">
          <PageToolbar
            actions={
              <TextInput
                aria-label="Search docs"
                placeholder="Search docs"
                size="xs"
                value={query}
                onChange={(event) => setQuery(event.currentTarget.value)}
              />
            }
          >
            Practical setup and operating guides for tracking, campaign channels, provider
            connections, and troubleshooting.
          </PageToolbar>

          <div className="app-docs__layout">
            <aside className="app-docs__sidebar" aria-label="Docs sections">
              {docsSections.map((section) => {
                const articles = visibleArticles.filter((article) => article.section === section)
                if (articles.length === 0) return null
                return (
                  <nav className="app-docs__nav-group" key={section} aria-label={section}>
                    <h2>{section}</h2>
                    {articles.map((article) => (
                      <a href={`#${article.slug}`} key={article.slug}>
                        {article.title}
                      </a>
                    ))}
                  </nav>
                )
              })}
            </aside>

            <main className="app-docs__content">
              {visibleArticles.map((article) => {
                const Article = article.component
                return (
                  <section id={article.slug} className="app-docs__article" key={article.slug}>
                    <AppCard>
                      <header className="app-docs__article-header">
                        <div>
                          <span>{article.section}</span>
                          <h2>{article.title}</h2>
                          <p>{article.description}</p>
                        </div>
                        <Group gap={6}>
                          {article.tags.map((tag) => (
                            <Badge color="gray" radius="sm" size="sm" variant="light" key={tag}>
                              {tag}
                            </Badge>
                          ))}
                        </Group>
                      </header>
                      <Article />
                    </AppCard>
                  </section>
                )
              })}
              {visibleArticles.length === 0 ? (
                <AppCard>
                  <h2>No docs found</h2>
                  <p>Try searching for tracking, events, Google, Meta, or troubleshooting.</p>
                </AppCard>
              ) : null}
            </main>
          </div>

          <footer className="app-docs__footer">
            <Link href="/openapi.json">OpenAPI JSON</Link>
          </footer>
        </div>
      )}
    </AuthenticatedAppShell>
  )
}
